import React from 'react';

import Input from 'components/input';
import Button from 'components/button';
import { useSelector } from 'store/hooks';
import request from 'request';
import styles from './create-modal.module.scss';
import users from '../users';

const EditUserModal = ({
	onClose,
	onEdit,
	selectedUser,
}: {
	selectedUser?: users.user;
	onClose: () => void;
	onEdit: () => void;
}) => {
	const user = useSelector((state) => state.user);
	const [email, setEmail] = React.useState(selectedUser?.email ?? '');
	const [password1, setPassword1] = React.useState('');
	const [password2, setPassword2] = React.useState('');
	const [role, setRole] = React.useState({
		key: selectedUser?.role ?? '',
		value: '',
	});
	const [pending, setPending] = React.useState(false);
	const [validError, setValidError] = React.useState<{
		name: 'email' | 'password1' | 'password2' | 'role';
		value: string;
	} | null>(null);

	const handleEdit = (e: React.FormEvent<HTMLFormElement>) => {
		e.preventDefault();
		if (email.trim().length < 5) {
			return setValidError({
				name: 'email',
				value: 'Minimum login length 5 characters',
			});
		} else if (password1.trim().length < 6) {
			return setValidError({
				name: 'password1',
				value: 'Minimum password length 6 characters',
			});
		} else if (password1.trim() !== password2.trim()) {
			return setValidError({
				name: 'password2',
				value: "The passwords don't match",
			});
		} else if (role.key === '') {
			return setValidError({
				name: 'role',
				value: 'Role is required',
			});
		} else setValidError(null);
		setPending(true);

		let body: any = {};
		if (password1.trim() !== '') body.password = password1;
		body.email = email;
		body.role = role.key;

		request
			.put('/admin/users/' + selectedUser?.id, body)
			.then(() => onEdit())
			.finally(() => setPending(false));
	};

	return (
		<div className={styles.modal} onMouseDown={onClose}>
			<form
				onSubmit={handleEdit}
				className={styles.modalWrap}
				onMouseDown={(event) => event.stopPropagation()}
			>
				<div className={styles.title}>Edit user</div>
				<div className={styles.inputs}>
					<div className={styles.input}>
						<Input title="Email" type="string" value={email} onInput={(value) => setEmail(value)} />
						{validError?.name === 'email' && (
							<div className={styles.inputError}>{validError.value}</div>
						)}
					</div>
					<div className={styles.input}>
						<Input
							title="Password"
							type="password"
							value={password1}
							onInput={(value) => setPassword1(value)}
						/>
						{validError?.name === 'password1' && (
							<div className={styles.inputError}>{validError.value}</div>
						)}
					</div>
					<div className={styles.input}>
						<Input
							title="Confirm password"
							type="password"
							value={password2}
							onInput={(value) => setPassword2(value)}
						/>
						{validError?.name === 'password2' && (
							<div className={styles.inputError}>{validError.value}</div>
						)}
					</div>
					{user.role === 'root' && (
						<div className={styles.input}>
							<Input
								id="role"
								title="Role"
								type="select"
								value={role.key}
								onSelect={(option) => setRole(option)}
								options={[
									{
										key: 'expert',
										value: 'Expert',
									},
									{
										key: 'admin',
										value: 'Admin',
									},
								]}
							/>
							{validError?.name === 'role' && (
								<div className={styles.inputError}>{validError.value}</div>
							)}
						</div>
					)}
				</div>
				<div className={styles.buttonGroup}>
					<Button color="orange" onClick={onClose}>
						Cancel
					</Button>
					<Button type="submit" color="green" pending={pending}>
						Edit
					</Button>
				</div>
			</form>
		</div>
	);
};

export default EditUserModal;
